import { UserState } from '@trustpad/launchpad/dist/staking/hooks/useStakingV2';

import dayjs from 'dayjs';
import * as React from 'react';
import { FaCheck, FaCoins, FaCross, FaTimes } from 'react-icons/fa';

import { DateTimeFormat } from '~config/constants';
import { ProgressBar } from '~features/ui';

export function UserDepositStatusAndProgress({
  user,
  lockPeriod,
}: {
  user: UserState;
  lockPeriod: number;
}) {
  const { amount, unlocksAt, isLocked } = user;
  const progress =
    100 -
    Math.min((1 / (lockPeriod / (unlocksAt - Date.now() / 1000))) * 100, 100);

  return (
    <div className="space-y-1">
      <div className="text-center text-sm tracking-wide">
        {isLocked ? (
          <>
            <FaCheck className="inline-block mr-1 text-green-500" />{' '}
            <span className="align-middle">Active, making money</span>{' '}
            <FaCoins className="animate-bounce inline-block ml-1" />
          </>
        ) : amount.gtn(0) ? (
          <>
            <FaTimes className="inline-block text-red-500" />{' '}
            <span className="align-middle">
              Inactive, renew or upgrade your staking
            </span>
          </>
        ) : (
          <>
            <FaTimes className="inline-block text-red-500" />{' '}
            <span className="align-middle">Inactive, stake a tier</span>
          </>
        )}
      </div>

      <ProgressBar progress={amount.gtn(0) || isLocked ? progress : 0} />

      <div className="flex justify-between text-sm space-x-3 secondary-text">
        {isLocked ? (
          <>
            <span>Locked. Early unstaking fee active</span>
            <span>
              unlocks on{' '}
              {dayjs.unix(unlocksAt).utc().format(DateTimeFormat.full)}
            </span>
          </>
        ) : amount.gtn(0) ? (
          <>
            <span>Unlocked</span>
            <span>
              {unlocksAt > 1595249226
                ? `on ${dayjs
                    .unix(unlocksAt)
                    .utc()
                    .format(DateTimeFormat.full)}`
                : null}
            </span>
          </>
        ) : null}
      </div>
    </div>
  );
}
